/** Placeholder do filtro do `Dropdown` e do `MultiSelect` (o Prime não tem chave de locale para ele). */
export const SELECT_FILTER_PLACEHOLDER = "Buscar";
